// sessionStorage: date filters shared across Insights ↔ Activities within a tab.
// `time_zone` is always an IANA name, never an Activities slot id ('mine').
// Resets when the tab closes — intentional, so stale dates don't surprise users.

import { pickBy } from 'lodash-es';

export function saveSessionFilters(orgId, { from, to, tab, user_id, team_id, time_zone }) {
  if (!orgId) {
    return;
  }
  try {
    const key = `session_filters_${orgId}`;
    const previous = JSON.parse(sessionStorage.getItem(key)) || {};
    // Merge over stored filters so an area that doesn't write a field can't wipe it
    // (Activities omits tab/team_id). Non-empty wins.
    const incoming = pickBy({ from, to, tab, user_id, team_id, time_zone }, (v) => v != null && v !== '');
    const next = { ...previous, ...incoming };

    // Only the member scope can be cleared: its writer owns both sides, so an explicit null drops
    // the stored id. Elsewhere a null means "not resolved yet", not "cleared".
    if (user_id === null) {
      delete next.user_id;
    }

    if (team_id === null) {
      delete next.team_id;
    }

    // Drop a carried-over range end when `from` moved but the caller set no matching `to`
    // (e.g. Activities saves a single day), so we never persist an inverted range.
    if (incoming.from && !incoming.to && previous.from !== incoming.from) {
      delete next.to;
    }

    sessionStorage.setItem(key, JSON.stringify(next));
  } catch { /* private browsing */ }
}

function isValidDateString(value) {
  return typeof value === 'string' && !Number.isNaN(Date.parse(value));
}

function isValidSessionFilter(data) {
  if (!data || typeof data !== 'object') {
    return false;
  }
  if (!isValidDateString(data.from)) {
    return false;
  }
  if (data.to != null && !isValidDateString(data.to)) {
    return false;
  }

  return true;
}

export function getSessionFilters(orgId) {
  if (!orgId) {
    return null;
  }
  try {
    const data = JSON.parse(sessionStorage.getItem(`session_filters_${orgId}`));

    return isValidSessionFilter(data) ? data : null;
  } catch {
    return null;
  }
}
